import React from 'react';

import { ReactComponent as Cadeado } from '../../../assets/rebranding/objetos/cadeado.svg';
import { Body, CardBase, Title } from '@icarros/ids-react';
import { CardBaseWrapper } from './style';

export function PhoneScamCardDefault(): JSX.Element {
  return (
    <CardBaseWrapper>
      <CardBase variant="default" selected={false} hasHover={false}>
        <Cadeado />
        <Title size="overline">O icarros não entra em contato pedindo seus dados nem códigos</Title>
        <Body variant="variant">
          Por isso, se entrarem em contato em nome do icarros é golpe! Nunca compartilhe suas
          senhas, protocolos de atendimento ou códigos (SMS, e-mail ou WhatsApp)
        </Body>
      </CardBase>
    </CardBaseWrapper>
  );
}
